/**
 * @file RelatedKeywordsRenderer.tsx
 * @description Custom cell renderer for displaying related keywords in AG Grid.
 * Renders keywords as "pill" elements within the grid cell.
 */

import React from "react";

const RelatedKeywordsRenderer: React.FC<{ value: string[] | undefined }> = ({ value }) => {
  const keywords = value || [];
  return (
    <div className="flex flex-wrap items-center w-full h-full gap-2 my-2">
      {keywords.map((keyword, index) => (
        <span
          key={index}
          className="flex items-center h-6 px-2 text-white bg-gray-500 rounded-full"
        >
          {keyword}
        </span>
      ))}
    </div>
  );
};

export default RelatedKeywordsRenderer;
